import { Link } from "react-router-dom";
import {useTranslation} from 'react-i18next';
import { ReactComponent as NoMatchParrot } from "../../assets/images/Parrot_excited_3.svg";

const NoMatch = () => {
    const {t: translate } = useTranslation();

    return (
        <section className="section section--no-match">
            <div className="container">
                <div className="no-match">
                    <NoMatchParrot />
                    <h1>{translate('polly-lost')}</h1>
                    <p>{translate('no-match-text')}</p>
                    <Link to="/" className="button button--success">Return to PollyWood</Link>
                </div>
            </div>
        </section>
    )
}

export default NoMatch;